module.exports = __webpack_public_path__ + "media/images/common/pankuzu-arrow-66bc146563ed54abaee760bf9f9bc88d.svg";